import React from 'react';
import PropTypes from 'prop-types';

import Button from '@/common/components/ui/Button';
import { CheckmarkCircleIcon } from '@/assets/ui';

import { StepMap } from '@/services/course/creation/course-step-map';
import CourseCreationService from '@/services/course/creation/course-creation-service';
import { CourseBuilderData } from 'course-types';

interface Props {
  courseData: CourseBuilderData;
  currentStep: number;
  onClick: (stepIndex: number) => void;
  completedSteps: Array<boolean>;
}

const StepsIndicator: React.FC<Props> = ({ courseData, currentStep, onClick, completedSteps }) => {
  const steps = Object.keys(StepMap).map((key) => {
    const stepNumber = parseInt(key, 10);
    const completed = completedSteps[stepNumber];

    const getStyle = (): string => {
      const isCurrentIndex = stepNumber === currentStep;
      const isEnabled =
        !CourseCreationService.isNextButtonEnabled(courseData, stepNumber) ||
        completedSteps[stepNumber - 1];

      if (isCurrentIndex) {
        return 'text-primary border-primary bg-surface_gray_25';
      } else if (completed) {
        return 'text-success border-success';
      } else if (isEnabled) {
        return 'text-text_gray_800 opacity-60 hover:opacity-100 border-border_gray_300';
      } else {
        return 'text-text_disabled cursor-not-allowed border-border_gray_300';
      }
    };

    return (
      <Button
        key={stepNumber}
        text={true}
        onClick={() => onClick(stepNumber)}
        className={`flex flex-1 rounded-none items-center justify-center border-b-2 py-3 px-4 font-medium ${getStyle()}`}
        disabled={!CourseCreationService.isNextButtonEnabled(courseData, stepNumber)}
      >
        <span className='flex items-center gap-2'>
          {StepMap[stepNumber].name}
          {completed && <CheckmarkCircleIcon className='w-[20px] h-[20px] text-success' />}
        </span>
      </Button>
    );
  });

  return (
    <div className='flex w-full border-b border-border_gray_300 bg-surface_gray_50'>{steps}</div>
  );
};

StepsIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default StepsIndicator;
